import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'
import { InstantFunding } from 'merchant-components'

export const Route = createFileRoute('/_merchant/_portal/instantfunding')({
  component: InstantFunding,
})
